import { render, staticRenderFns } from "./ConfirmRemoveShippingAddress.vue?vue&type=template&id=7f499ab2"
import script from "./ConfirmRemoveShippingAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemoveShippingAddress.vue?vue&type=style&index=0&id=7f499ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports